import React, { useEffect, useState } from "react";
import { ArrowBackIos } from "@mui/icons-material";
import history from "../../../libs/history.utils";
import styles from "./Style.module.css";
import ShadowBox from "../../../components/ShadowBox/ShadowBox";
import ImageInfoToolTip from "../../../components/ImageInfo/ImageInfo";
import CustomFileField from "../../../components/FileField/CustomFileField";
import MultiComplete from "../../../components/FormFields/AutoCompleteText/MultiComplete";
import CustomTextField from "../../../components/FormFields/TextField/TextField.component";
import UploaderImage from "../../../components/FileComponent/UploaderImage.component";
import { PrimaryButton } from "../../../components/Buttons/PrimaryButton";
import { ButtonBase, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import NewEditor from "../../../components/NewEditor/NewEditor.component";
import HtmlEditor from "../../../components/NewEditor/HtmlEditor.component";
import { useTheme } from "@mui/styles";
import useHealthTipsHook from "./HealthTipsHook";
import CustomDateTimePicker from "../../../components/FormFields/DatePicker/CustomDateTimePicker";
import CustomIosSwitch from "../../../components/FormFields/CustomIosSwitch";
// import defaultImg from "../../../assets/CRMAssets/default_quiz_health_tip.jpg";
const HealthTips = ({location}) => {
  const {
    errorData,
    form,
    onBlurHandler,
    changeTextData,
    handleSubmit,
    listData,
    descriptionRef,
    isSubmitting,
    id,
    programList,
    defaultImg,
    isDuplicate,
    image,
    customerDetails
  } = useHealthTipsHook({location});
  const theme = useTheme();

  return (
    <>
      <div className={styles.outerFlex1}>
        <div className={styles.iconButton}>
          <ButtonBase onClick={() => history.goBack()}>
            <ArrowBackIos fontSize={"small"} />{" "}
          </ButtonBase>
          <Typography variant={"title1"}>
            {isDuplicate ? "Add" : id ? "Update" : "Add"} Health and Wellness Tip
          </Typography>
        </div>
      </div>
      <ShadowBox className={styles.contact}>
        <div className={"headerFlex"}>
          <Typography variant={"h5"} className={"heading"} sx={{ mb: 2 }}>
          Tip Information
          </Typography>
        </div>
        <div className={styles.formFlex}>
          <div className={styles.count}>
            <CustomFileField
              maxSize={10 * 1024 * 1024}
              type={["jpg", "png", "jpeg"]}
              name="image"
              accept={"image/*"}
              error={errorData?.image}
              onChange={(file) => {
                if (file) {
                  changeTextData(file, "image");
                }
              }}
              value={form?.image}
              defaultImage={image}
              render={({ value, url, error, ...rest }) => (
                <UploaderImage
                placeholder="Upload Image"
                  Banner
                  error={error}
                  value={value}
                  default_image={image}
                  label={
                    <>
                      Upload Program logo
                      <span style={{ color: theme.palette.error.main }}>*</span>
                    </>
                  }
                  url={url}
                  {...rest}
                />
              )}
            />
            <div className={styles.imageGuide}>
              <Typography variant="subtitle1">Image Guide</Typography>
              <ImageInfoToolTip
                resolution={
                  <div className={styles.new_line}>
                    <div> Resolution 1280px * 720px</div>

                    <div>Image size = 10MB</div>
                  </div>
                }
              />
            </div>
          </div>
          <div className={styles.lowerWrap}>
            <div className={styles.formFlex}>
              <div className={styles.formGroup}>
                <CustomTextField
                  isError={errorData?.title}
                  errorText={errorData?.title}
                  label={
                    <>
                      Title{" "}
                      <span style={{ color: theme.palette.error.main }}>*</span>
                    </>
                  }
                  value={form?.title}
                  onTextChange={(text) => {
                    changeTextData(text, "title");
                  }}
                  onBlur={() => {
                    onBlurHandler("title");
                  }}
                />
              </div>
            </div>
            <div className={styles.formFlex}>
              <div className={styles.formGroup}>
                <CustomTextField
                  isError={errorData?.link}
                  errorText={errorData?.link}
                  label={"Link"}
                  value={form?.link}
                  onTextChange={(text) => {
                    changeTextData(text, "link");
                  }}
                  onBlur={() => {
                    onBlurHandler("link");
                  }}
                />
              </div>
            </div>
            <div className={styles.formFlex}>
              <div className={styles.formGroup}>
                <CustomTextField
                  isError={errorData?.short_brief}
                  errorText={errorData?.short_brief}
                  label={
                    <>
                      Short Brief{" "}
                      <span style={{ color: theme.palette.error.main }}>*</span>
                    </>
                  }
                 
                  value={form?.short_brief}
                  onTextChange={(text) => {
                    changeTextData(text, "short_brief");
                  }}
                  onBlur={() => {
                    onBlurHandler("short_brief");
                  }}
                />
              </div>
            </div>
            <div className={styles.formFlex}>
              <div className={styles.formGroup}>
              <Typography variant="subtitle1" sx={{ mb: 1, ml: 0.5 }}>
           
           <>Description <span style={{ color: theme.palette.error.main }}>*</span></>
         </Typography>
         <HtmlEditor
           buttonList={true}
           editorData={form?.description}
           error={errorData?.description}
           handleChangeEditor={(html) => {          
             descriptionRef.current(html, "description");
           }}
         />
              </div>
            </div>
          </div>
        </div>
      </ShadowBox>
     
      <ShadowBox className={styles.contact}>
        <div className={"headerFlex"}>
          <Typography variant={"h5"} className={"heading"} sx={{ mb: 2 }}>
            Additional Details
          </Typography>
        </div>
        <div className={`${styles.formFlex} ${styles.marginLeft}`}>
          <div className={styles.formGroup}>
          <CustomDateTimePicker
            clearable
            label={
              <>
                Date & time of pushing on app{" "}
                <span style={{ color: theme.palette.error.main }}>*</span>
              </>
            }
            // maxDate={new Date()}
            onChange={(date) => {
              changeTextData(date, "start_date");
            }}
            value={form?.start_date}
            isError={errorData?.start_date}
          />
          </div> 
          <div className={styles.formGroup}>
            <MultiComplete
              isError={errorData?.client_id}
              disabled={!!location?.state && !isDuplicate}
              AutoCompleteList={listData?.CLIENTS ? listData?.CLIENTS : []}
              label={
                <>
                Select Client{" "}
                <span style={{ color: theme.palette.error.main }}>*</span>
              </>
              }
              value={form?.client_id}
              onTextChange={(text) => {
                changeTextData(text, "client_id");
              }}
              enableField={["title"]}
              style={{ marginTop: "-0.5px" }}
            />
          </div>
        </div>
        <div className={`${styles.formFlex} ${styles.marginLeft}`}>
          <div className={styles.formGroup}>
          <MultiComplete
              size={"small"}
              multiple
              id="tags-outlined"
              AutoCompleteList={programList ? programList : []}
              label={
                <>
                  Select Program{" "}
                  <span style={{ color: theme.palette.error.main }}>*</span>
                </>
              }
              value={form?.program_ids}
              isError={errorData?.program_ids}
              disabled={!form?.client_id?.id || (!!location?.state && !isDuplicate)}
              sx={{
                backgroundColor: form?.client_id ? 'inherit' : '#F7F7F7', 
                
              }}
              errorText={errorData?.program_ids}
              onTextChange={(selectedItems) => {
                changeTextData(selectedItems, "program_ids");
              }}
              enableField={["label"]}
            />
          </div>
          
        </div>
        <div className={`${styles.formFlex} ${styles.marginLeft}`}>
              <div className={styles.formGroup}>
              { id && !isDuplicate && (
                <CustomTextField
                  isError={errorData?.update_reason}
                  errorText={errorData?.update_reason}
                  label={<>Reason for update <span style={{ color: theme.palette.error.main }}>*</span></>}
                  value={form?.update_reason}
                  multiline
                  rows="3"
                  onTextChange={(text) => {
                    changeTextData(text, "update_reason");
                  }}
                  onBlur={() => {
                    onBlurHandler("update_reason");
                  }}
                />
              )}
              </div>
            </div>
        <div className={`${styles.formFlex} ${styles.marginLeft} `}>
        <div className={styles.formGroup}>
          { id && !isDuplicate && customerDetails?.status && customerDetails?.status !== "SCHEDULED" && (
          <div >
          <Typography variant="subtitle1">
          Status
          </Typography>
          <CustomIosSwitch
                          value={form?.status}
                          checked={form?.status ? true : false}
                          handleChange={() => {
                            changeTextData(!form?.status, "status");
                          }}

                          label={form?.status ? "Active" : "Inactive"}
                        />
          </div>
          )}
          </div>

        </div>
      </ShadowBox>
      <div className={styles.saveButton}>
        <PrimaryButton
          color={"primary"}
          sx={{ mt: 4 }}
           onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {/* {id ? "SAVE" : "CREATE"} */}
          {isSubmitting ? (
            <CircularProgress size={24} color={"primary"} />
          ) : isDuplicate ? (
            "CREATE"
          ) : id ? (
            "SAVE"
          ) : (
            "CREATE"
          )}
        </PrimaryButton>
      </div>
    </>
  );
};

export default HealthTips;
